import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89mmTiltControlMidRailRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters89"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={41.4}
          y1={502.04}
          x2={41.4}
          y2={472.16}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={7082.84}
          y1={502.04}
          x2={7082.84}
          y2={472.16}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={41.4}
          y1={532.38}
          x2={41.4}
          y2={502.51}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={7082.84}
          y1={532.38}
          x2={7082.84}
          y2={502.51}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={41.4}
          y1={562.61}
          x2={41.4}
          y2={532.74}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={7082.84}
          y1={562.61}
          x2={7082.84}
          y2={532.74}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={41.4}
          y1={592.76}
          x2={41.4}
          y2={562.89}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={7082.84}
          y1={592.76}
          x2={7082.84}
          y2={562.89}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={41.4}
          y1={623}
          x2={41.4}
          y2={593.12}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={7082.84}
          y1={623}
          x2={7082.84}
          y2={593.12}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={41.4}
          y1={680.33}
          x2={41.4}
          y2={650.46}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7082.84}
          y1={680.33}
          x2={7082.84}
          y2={650.46}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={41.4}
          y1={710.58}
          x2={41.4}
          y2={680.7}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7082.84}
          y1={710.58}
          x2={7082.84}
          y2={680.7}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={41.4}
          y1={740.8}
          x2={41.4}
          y2={710.93}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7082.84}
          y1={740.8}
          x2={7082.84}
          y2={710.93}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={41.4}
          y1={771.06}
          x2={41.4}
          y2={741.18}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7082.84}
          y1={771.06}
          x2={7082.84}
          y2={741.18}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={41.4}
          y1={801.25}
          x2={41.4}
          y2={771.38}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7082.84}
          y1={801.25}
          x2={7082.84}
          y2={771.38}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={349.94}
          y1={490.25}
          x2={349.94}
          y2={485.6}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={460.9}
          y1={490.25}
          x2={460.9}
          y2={485.6}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={349.94}
          y1={519.79}
          x2={349.94}
          y2={515.14}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={460.9}
          y1={519.79}
          x2={460.9}
          y2={515.14}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={349.94}
          y1={549.24}
          x2={349.94}
          y2={544.59}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={460.9}
          y1={549.24}
          x2={460.9}
          y2={544.59}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={349.94}
          y1={578.61}
          x2={349.94}
          y2={573.95}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={460.9}
          y1={578.61}
          x2={460.9}
          y2={573.95}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={349.94}
          y1={608.06}
          x2={349.94}
          y2={603.41}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={460.9}
          y1={608.06}
          x2={460.9}
          y2={603.41}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={460.9}
          y1={669.76}
          x2={460.9}
          y2={665.12}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={349.94}
          y1={669.76}
          x2={349.94}
          y2={665.12}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={349.94}
          y1={699.15}
          x2={349.94}
          y2={694.51}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={460.9}
          y1={699.15}
          x2={460.9}
          y2={694.51}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={349.94}
          y1={728.53}
          x2={349.94}
          y2={723.89}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={460.9}
          y1={728.53}
          x2={460.9}
          y2={723.89}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-37"
          x1={460.9}
          y1={757.92}
          x2={460.9}
          y2={753.28}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-38"
          x1={349.94}
          y1={757.92}
          x2={349.94}
          y2={753.28}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-39"
          x1={349.94}
          y1={787.3}
          x2={349.94}
          y2={782.66}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-40"
          x1={460.9}
          y1={787.3}
          x2={460.9}
          y2={782.66}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <pattern
          id="prefix__SVGID_1_"
          data-name="SVGID 1"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 1.06 618.1 1370.05)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 -.94 491.34 522.67)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-2">
            <use
              id="prefix__image-3"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <pattern
          id="prefix__SVGID_1_7"
          data-name="SVGID 1 7"
          width={135}
          height={135}
          patternTransform="matrix(.98 0 0 -1.32 485.91 332.1)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-3-2" data-name="image-3">
            <use
              id="prefix__image-4"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <pattern
          id="prefix__SVGID_1_7-3"
          data-name="SVGID 1 7-3"
          width={135}
          height={135}
          patternTransform="matrix(.99 0 0 -1.32 308.94 332.09)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-4-2" data-name="image-4">
            <use
              id="prefix__image-5"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <pattern
          id="prefix__SVGID_1_7-5"
          data-name="SVGID 1 7-5"
          width={135}
          height={135}
          patternTransform="matrix(.97 0 0 -1.32 463.8 153.98)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-5-2" data-name="image-5">
            <use
              id="prefix__image-6"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <pattern
          id="prefix__SVGID_1_7-7"
          data-name="SVGID 1 7-7"
          width={135}
          height={135}
          patternTransform="matrix(.98 0 0 -1.32 485.94 332.27)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-6-2" data-name="image-6">
            <use
              id="prefix__image-7"
              data-name="image"
              className="prefix__cls-2"
              transform="matrix(1 0 0 -1 0 135)"
              xlinkHref="#prefix__image-2-2"
            />
          </g>
        </pattern>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-47,.prefix__cls-52,.prefix__cls-6{fill:none}.prefix__cls-2,.prefix__cls-47,.prefix__cls-52{isolation:isolate}.prefix__cls-47,.prefix__cls-52{opacity:.15}.prefix__cls-5{fill:#333}.prefix__cls-47,.prefix__cls-52,.prefix__cls-6{stroke:#4d4d4d;stroke-miterlimit:10}.prefix__cls-47,.prefix__cls-6{stroke-width:.81px}.prefix__cls-52{stroke-width:.95px}.prefix__cls-57{fill:gray;opacity:.2}'
          }
        </style>
        <image
          id="prefix__image-2-2"
          width={135}
          height={135}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVR4Xu3SMRGAMADAwFL/xmqAHSXUQHMI4H/OmOu51zvgYH4F/Jc5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SBszfASNAbiFZQAAAABJRU5ErkJggg=="
        />
      </defs>
      <path
        d="M513.9 12.74H12.63v383.52h528.74V12.74zm-217 27h106v13.89h-106zm0 18.47h106v24.86h-106zm0 29.54h106v24.75h-106zm0 29.44h106V142h-106zm0 29.44h106v24.77h-106zm0 29.45h106V191h-106zm0 41.91h106v15.1h-106zm0 19.79h106v24.75h-106zm0 29.35h106v24.75h-106zm0 29.35h106v24.75h-106zm0 29.44h106v24.75h-106zm0 29.35h106v14h-106zm217 14h-106v-14h106zm0-18.57h-106v-24.77h106zm0-29.44h-106v-24.77h106zm0-29.35h-106v-24.77h106zm0-29.35h-106v-24.77h106zm0-29.44h-106V218h106zm0-42.1h-106v-14.93h106zm0-19.6h-106v-24.78h106zm0-29.44h-106V117.2h106zm0-29.35h-106V87.76h106zm0-29.45h-106v-25h106zm0-29.53h-106v-13.9h106z"
        fill="url(#shutters89)"
      />
      <g opacity={0.15}>
        <path
          className="prefix__cls-5"
          d="M14.64 72.19h.38v35.73h-.38zM538.89 72.19h2v35.73h-2z"
        />
        <path
          className="prefix__cls-5"
          d="M513.42 12.28H296.47v.09h-39v-.09H12.16v384.45h245.38v-.1h39v.1H542V12.28zm-472.83.93h216v26.07h-216zm-28.34 323.6v-35.73h.38v35.73zm27.38 59H13.11v-59H15v-35.73h-1.89V13.21h26.52zm217 0h-216v-26.09h216v26.09zm0-117.78H151.07v1h106v29.91l-.47-.56H151.07v.94h106v29.82l-.47-.57H151.07v.94h106v29.91l-.47-.56H151.07v.47h-5v-.47H40.59v-29.4h105.52v-.94H40.59v-29.37h105.52v-.94H40.59v-29.35h105.52v-.94H40.59v-29.35h105.52v-.94H40.59v-29.35h105.52v-.18h5v.37h106v29.91l-.47-.56H151.07v.94h106v29.91M40.59 217.53v-26.06h216v26.06zM257.06 70l-.47-.57H151.07v1h106v29.91l-.47-.57H151.07v.94h106v30l-.47-.65H151.07v1h104.37V131h1.62v29.9l-.47-.56H151.07v.93h106v29.91l-.47-.56H151.07v.38h-5v-.38H40.59v-29.35h105.52v-.93H40.59v-29.45h1.62v.1h103.9v-1H40.59V100.7h105.52v-.94H40.59V70.51h105.52v-1H40.59V40.22h105.52v-.38h5v.38h106zm19.56 325.84h-19.08V13.12h19.08zm20.8-382.67h216v26.11h-216zm-.86 177.32l-.09 27.94h.09v150.35h-.09v27.1h-19.09V13.12h19.09v27.1h.09zm216.86 205.3h-216v-26.07h216zm.48-158h-.48v24.75h.48v4.69h-.48V292h.48v4.68h-.48v24.57h.48v4.69h-.48v24.75h.48v4.69h-.48v13.51h-216.1v-13.52h-.38v-4.69h.38v-24.75h-.38v-4.69h.38v-24.75h-.38v-4.69h.38V267h-.38v-4.68h.38v-24.53h-.38v-4.69h.38v-14.63h216.1v14.63h.48zm-216.48-20.26v-26.06h216v26.06zM513.9 58.22h-.48v24.85h.48v4.69h-.48v24.75h.48v4.69h-.48V142h.48v4.68h-.48v24.72h.48v4.69h-.48v14.44h-216.1v-14.44h-.38v-4.69h.38v-24.76h-.38V142h.38v-24.8h-.38v-4.69h.38V87.76h-.38v-4.69h.38V58.22h-.38v-4.69h.38V40.22h216.1v13.41h.48zm27.47 49.7h-.47v193.16h.47v35.73h-.47v59h-26.53V13.21h26.53v59h.47z"
        />
        <path className="prefix__cls-5" d="M538.89 301.08h2v35.73h-2z" />
        <path
          className="prefix__cls-6"
          d="M146.11 39.75h4.96v151.06h-4.96zM146.11 218.1h4.96v151.06h-4.96z"
        />
      </g>
      <path
        fill="url(#prefix__linear-gradient)"
        d="M42.21 40.22h-1.62v29.82l1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M255.44 40.22h1.62v29.82l-1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M42.21 70.5h-1.62v29.92l1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M255.44 70.5h1.62v29.92l-1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M42.21 100.7h-1.62v29.91l1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M255.44 100.7h1.62v29.91l-1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M42.21 130.89h-1.62v29.91l1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M255.44 130.89h1.62v29.91l-1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M42.21 161.09h-1.62V191l1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M255.44 161.09h1.62V191l-1.62-29.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.21 218.47h-1.62v29.82l1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M255.44 218.47h1.62v29.82l-1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.21 248.66h-1.62v29.92l1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M255.44 248.66h1.62v29.92l-1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.21 278.95h-1.62v29.82l1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M255.44 278.95h1.62v29.82l-1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.21 309.14h-1.62v29.92l1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M255.44 309.14h1.62v29.92l-1.62-29.92z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.21 339.43h-1.62v29.82l1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M255.44 339.43h1.62v29.82l-1.62-29.82z"
      />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M296.94 53.63h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M407.9 53.63h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M296.94 83.16h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M407.9 83.16h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M296.94 112.61h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M407.9 112.61h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M296.94 141.96h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M407.9 141.96h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M296.94 171.4h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M407.9 171.4h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-31)"
        d="M407.9 233.1h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-32)"
        d="M296.94 233.1h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-33)"
        d="M296.94 262.54h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-34)"
        d="M407.9 262.54h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-35)"
        d="M296.94 291.89h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-36)"
        d="M407.9 291.89h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-37)"
        d="M407.9 321.24h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-38)"
        d="M296.94 321.24h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-39)"
        d="M296.94 350.68h106v4.69h-106z"
      />
      <path
        fill="url(#prefix__linear-gradient-40)"
        d="M407.9 350.68h106v4.69h-106z"
      />
      <path
        className="prefix__cls-47"
        d="M402.94 218.1h4.96v151.06h-4.96zM402.94 40.12h4.96v151.06h-4.96z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        opacity={0.2}
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        fill="none"
        d="M0 0h555.2v410H0z"
      />
      <path
        d="M0 0v410h555.2V0zm542 396.75H13.25V13.25H542z"
        fill="url(#shutters89)"
      />
      <path
        d="M554.2 1v408H1V1h553.2M12.25 397.75H543V12.25H12.25v385.5M555.2 0H0v410h555.2zM13.25 396.75V13.25H542v383.5z"
        fill="#4d4d4d"
        opacity={0.2}
      />
      <path
        className="prefix__cls-52"
        d="M405.35 31a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.33a4.29 4.29 0 014.29-4.25z"
      />
      <path fill="url(#prefix__SVGID_1_7)" d="M403.34 38.43h4.14v2.5h-4.14z" />
      <path
        className="prefix__cls-52"
        d="M407.96 39.32v-3.06h-5.08v3.06M148.52 31a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.32a4.29 4.29 0 014.29-4.26z"
      />
      <path fill="url(#prefix__SVGID_1_7-3)" d="M146.5 38.44h4.17v2.5h-4.17z" />
      <path
        className="prefix__cls-52"
        d="M151.13 39.33v-3.06h-5.08v3.06M148.58 209.08a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.29a4.29 4.29 0 014.29-4.29z"
      />
      <path
        fill="url(#prefix__SVGID_1_7-5)"
        d="M146.57 216.55h4.08v2.5h-4.08z"
      />
      <path
        className="prefix__cls-52"
        d="M151.13 217.53v-3.06h-5.08v3.06M405.38 209.34a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.29a4.29 4.29 0 014.29-4.29z"
      />
      <path
        fill="url(#prefix__SVGID_1_7-7)"
        d="M403.37 216.81h4.14v2.5h-4.14z"
      />
      <path className="prefix__cls-52" d="M407.99 217.7v-3.06h-5.08v3.06" />
      <path
        className="prefix__cls-57"
        d="M550.84 4.38l3.37-3.39v407.99l-3.37-3.36V4.38zM4.38 4.38L1.01.99v407.99l3.37-3.36V4.38zM4.37 405.64l-3.38 3.37h553.22l-3.36-3.37H4.37z"
      />
      <path
        className="prefix__cls-57"
        d="M4.37 4.36L.99.99h553.22l-3.36 3.37H4.37z"
      />
    </svg>
  );
};
